<template>
  <div class="row no-gutters">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="col-md-12 mb-2 h-inherit">
      <div class="align-center h-inherit">
        <ul class="nav nav-pills nav-fill bg-dark p-0">
          <li class="nav-item">
            <a class="nav-link text-white pointer" :class="{'active-item': activeTab === 'cameras'}" @click="activeTab = 'cameras'">
              <i class="fa fa-camera"></i>
              {{ $t('UI_DEVICE_COMTROL_CAMERAS') }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white pointer" :class="{'active-item': activeTab === 'encoder'}" @click="activeTab = 'encoder'">
              <i class="fa fa-hdd"></i>
              {{ $t('UI_DEVICE_COMTROL_ENCODER') }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-white pointer" :class="{'active-item': activeTab === 'streamer'}" @click="activeTab = 'streamer'">
              <i class="fa fa-stream"></i>
              {{ $t('UI_DEVICE_COMTROL_STREAMER') }}
            </a>
          </li>
        </ul>


      </div>
    </div>

    <!-- Tab Content -->
    <CameraDeviceTab v-if="activeTab === 'cameras'" />
    <EncoderDeviceTab v-if="activeTab === 'encoder'"/>
    <StreamerDeviceTab v-if="activeTab === 'streamer'"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

import CameraDeviceTab from './DeviceTabs/CameraDeviceTab';
import EncoderDeviceTab from './DeviceTabs/EncoderDeviceTab';
import StreamerDeviceTab from './DeviceTabs/StreamerDeviceTab';

const DeviceControlRepository = RepositoryFactory.get('devicecontrol');

export default {
  name: 'DeviceControlPanel',
  components: {
    StreamerDeviceTab,
    EncoderDeviceTab,
    CameraDeviceTab,
    Loading,
    SweetModal,
  },
  data() {
    return {
      isLoading: false,
      activeTab: 'cameras',
    };
  },
  mounted() {
    this.listDevices();
  },
  computed: {
    streamers() {
      return this.$store.state.deviceControlList.filter(device => device.type === 'streamer');
    },
  },
  methods: {
    async listDevices() {
      this.isLoading = true;
      await DeviceControlRepository.list()
        .then((response) => {
          this.isLoading = false;
          this.$store.commit('setDeviceControlList', response.data.devices);
        });
    },
  },
};
</script>

<style scoped>
  .active-item {
    background-color: #49525b;
  }
</style>
